module.exports = __webpack_public_path__ + "img/Christopher Jurcisin.dbe48554.jpg";